import React from 'react';
import { OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { Agreement } from 'types/agreementTypes';
import { List } from 'antd';
import { useSelector } from 'react-redux';
import { hasPermission } from 'utils/utils';
import { RootState } from 'store/store';
import { useTranslation } from 'react-i18next';

interface AgreementFormProps {
    selectedAgreement: Agreement | null;
    type: string;
    setType: (type: string) => void;
}

const AgreementForm: React.FC<AgreementFormProps> = ({ selectedAgreement, type, setType }) => {
    const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);
    const tokenScopeList = useSelector((state: RootState) => state.auth.auth.data[0]?.tokenScopeList || []);
    const hasAgreementsRead = hasPermission(tokenScopeList, orgId, 'o', 'agreements:r');
    const hasAgreementsWrite = hasPermission(tokenScopeList, orgId, 'o', 'agreements:w');
    const { t } = useTranslation();

    const availability = [
        { label: t('agreement.form.forInvitation'), name: 'forInvitation', valuePropName: 'checked' },
        { label: t('agreement.form.forSignIn'), name: 'forSignIn', valuePropName: 'checked' },
    ];
    return (
        <>
            <OpForm.Input label={t('agreement.form.name')} name="name" rules={[{ required: true, message: t('agreement.form.nameRequired') }]} />
            <OpForm.Input label={t('agreement.form.description')} name="description" />
            {!selectedAgreement && (
                <OpForm.Select
                    name='type' label={t('agreement.form.type')}
                    onChange={(value) => setType(value as string)}
                    options={[
                        { label: t('agreement.form.text'), value: "text" },
                    ]}
                />
            )}
            {type === 'url' && (
                <OpForm.Input name="content" label={t('agreement.form.documentUrl')} />
            )}
            {selectedAgreement && (
                <OpForm.Input disabled label={t('agreement.form.updatedAt')} name="updatedAt" />
            )}
            <List
                header={t('agreement.form.availabilityTitle')}
                dataSource={availability}
                bordered
                renderItem={item => (
                    <List.Item>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <OpForm.Switch
                                name={item.name} style={{ marginBottom: 0 }}
                                disabled={!hasAgreementsWrite && hasAgreementsRead} />
                            <span style={{ marginLeft: 8 }}>{item.label}</span>
                        </div>
                    </List.Item>
                )}
            />
        </>
    );
};

export default AgreementForm;
